var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('div',{staticClass:"hidden-theme-switcher",on:{"click":function($event){_vm.$vuetify.theme.dark = !_vm.$vuetify.theme.dark}}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }